<template>
  <div v-if="loading" class="preloader" >
    <div class="load">

    <hr/><hr/><hr/><hr/>
</div>
  </div>
  <div class="home">
    <HeaderComponent />
    <HeroComponent />
    <div class="element">
      <AboutComponent/>
      <ServicesComponent/>
      <ourservicesComponent/>
      <FeatureComponent/>
      <NossosClienteComponent/>
      <patnersComponent/>
      <contactComponent/>
    </div>


  </div>
</template>

<script >
import ScrollReveal from 'scrollreveal';


import imagem from '@/assets/img/logofundo.png';

import AboutComponent from '@/components/About/AboutComponent.vue';
import BlogComponent from '@/components/Blog/blogComponent.vue';
import FeatureComponent from '@/components/Feature/featureComponent.vue';
import HeaderComponent from '@/components/Header/headerComponent.vue';
import HeroComponent from '@/components/Hero/heroComponent.vue';
import ServicesComponent from '@/components/Services/servicesComponent.vue';
import ourservicesComponent from '@/components/Services/ourservicesComponent.vue';
import servicesComponent from '@/components/Services/servicesComponent.vue';
import NossosClienteComponent from '@/components/Team/NossosClienteComponent.vue';
import patnersComponent from '@/components/Team/patnersComponent.vue';
import contactComponent from '@/components/About/contactComponent.vue';
//import oursteamComponent from '@/components/Team/oursteamComponent.vue';





  export default{
    components:{
      HeaderComponent,
      HeroComponent,
      AboutComponent,
      ServicesComponent,
      FeatureComponent,
      BlogComponent,
      ourservicesComponent,
      servicesComponent,
      NossosClienteComponent,
      patnersComponent,
      contactComponent
    },
    data(){
      return{
        backgroundImagem:`url(${imagem})`,
         loading: true
      };

    },
    mounted() {
    ScrollReveal().reveal('.element', {
      origin: 'top',
      distance: '50px',
      duration: 4000,
      delay: 100,
      reset: false,
      origin:'left'
    });

    ScrollReveal().reveal('#about p, #about h3', {
      origin: 'bottom',
      distance: '30px',
      duration: 1000,
      delay: 100,
      interval: 200,
      reset: true
    });

    ScrollReveal().reveal('.icon', {
      origin: 'left',
      distance: '20px',
      duration: 800,
      delay: 100,
      reset: true
    });
if (!sessionStorage.getItem("preloaderShown")) {
  // Primeira vez que a home é acessada: mostra o preloader
  this.loading = true;

  setTimeout(() => {
    // Após 2 segundos, esconde o preloader
    this.loading = false;
    // Marca que o preloader já foi exibido
    sessionStorage.setItem("preloaderShown", "true");
  }, 2000);
} else {
  // Já foi exibido antes nesta sessão: não mostra
  this.loading = false;
}
  }
  }
</script>

<style scoped>
hr{
  opacity: 1 !important;
}
.text-copy{
  margin-bottom: 40%;

}
.text-copy h1{
  font-weight: bold;
  font-family: "Poppins", sans-serif;
}

.element{
  background-image: v-bind(backgroundImagem) ;
  background-size: 60%;
  background-repeat: no-repeat;
  background-position: right;
  background-position-x: 170%;

}
.preloader {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: white;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  transition: opacity 1s ease;
}

.loading {
  border: 6px solid #f3f3f3;
  border-top: 6px solid #3498db;
  border-radius: 50%;
  width: 60px;
  height: 60px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* Animacao */

.load{position:absolute;top:50%;left:50%;transform:translate(-50%, -50%);
  /*change these sizes to fit into your project*/
  width:100px;
  height:100px;
}
.load hr{border:0;margin:0;width:40%;height:40%;position:absolute;border-radius:50%;animation:spin 2s ease infinite}


.load :first-child{background:var( --menu-color);animation-delay:-1.5s}
.load :nth-child(2){background:var( --menu-color);animation-delay:-1s}
.load :nth-child(3){background:var( --menu-color);animation-delay:-0.5s}
.load :last-child{background:var( --menu-color)}

@keyframes spin{
  0%,100%{transform:translate(0)}
  25%{transform:translate(160%)}
  50%{transform:translate(160%, 160%)}
  75%{transform:translate(0, 160%)}
}
</style>